<template>
  <div class="opt">
    <template v-if="special.length > 0">
      <div class="sn-f-b-s" :key="i" v-for="(item, i) in special">
        <div class="sn-f-s-0 opt-title">{{ item.title }}：</div>
        <div class="sn-f-1 sn-f-s-c sn-f-wrap opt-region">
          <div class="sn-f-c-c sn-pointer opt-blank system" :class="{'interaction': parseFloat(option.value) === parseFloat(rechargeEntry)}"
          :key="j" v-for="(option, j) in item.option" @click="changeRechargeEntry(option.value);">{{ option.label + option.value }}元</div>
        </div>
      </div>
      <div class="sn-f-b-s">
        <div class="sn-f-s-0 opt-title">其他金额：</div>
        <div class="sn-f-1 sn-f-s-c sn-f-wrap opt-region">
          <input class="opt-blank" type="number" placeholder="输入金额" v-model="rechargeEntry" @input="inputRechargeEntry">
        </div>
      </div>
    </template>
    <div class="sn-f-b-s" v-else>
      <div class="sn-f-s-0 opt-title">{{ $sn.getConfig('outRechargeLabel') }}金额：</div>
      <div class="sn-f-1 sn-f-s-c sn-f-wrap opt-region">
        <div class="sn-f-c-c sn-pointer opt-blank system" :class="{'interaction': parseFloat(item) === parseFloat(rechargeEntry)}"
        :key="i" v-for="(item, i) in option" @click="changeRechargeEntry(item);">{{ item }}元</div>
        <template v-if="card !== perpetual.IN_CARD_CLINIC_TYPE || (card === perpetual.IN_CARD_CLINIC_TYPE && $sn.getConfig('isInRechargeEntrySum'))">
          <input class="opt-blank" type="number" placeholder="输入金额" v-model="rechargeEntry" @input="inputRechargeEntry">
        </template>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import * as Constants from '@/common/utils/constants.js';

export default {
  name: 'opt',
  props: {
    card: {
      type: String,
      default: Constants.OUT_CARD_CLINIC_TYPE
    },
    option: {
      type: Array,
      default: function() {
        return ['10', '50', '100', '200', '500', '1000', '2000'];
      }
    }
  },
  data() {
    return {
      perpetual: Constants,
      special: [],
      rechargeEntry: ''
    };
  },
  created: function() {
    const config = {
      [this.perpetual.HOSPITAL_ID_SDSL]: '/hos/ui/hospital/sdsl/js/recharge-option.js',
      [this.perpetual.HOSPITAL_ID_SDQL]: '/hos/ui/hospital/sdql/js/recharge-option.js'
    }[this.$sn.utils.getHospitalId()];
    if (this.card === this.perpetual.OUT_CARD_CLINIC_TYPE && config) {
      this.$sn.utils.ordinaryRequest({
        domain: 'static',
        url: config + '?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
      }).then(result => {
        if (result && this.$sn.validate.array(result) && result.length > 0) {
          this.special = result;
        }
      });
    }
  },
  methods: {
    changeRechargeEntry(item) {
      this.rechargeEntry = item;
      this.$emit('sendBack', this.rechargeEntry);
    },
    inputRechargeEntry(e) {
      const seize = e.target.value;
      const value = seize.trim().slice(0, seize.indexOf('.') === -1 ? seize.length : seize.indexOf('.') + 3);
      this.rechargeEntry = value;
      this.$emit('sendBack', this.rechargeEntry);
    }
  }
};
</script>
<style lang="scss" scoped>
.opt {
  overflow: hidden;
  width: 100%;

  &-title {
    @include fs(16);

    width: 100px;
    font-weight: bold;
    color: $text1;
  }

  &-region {
    overflow: hidden;
    width: 100%;

    .opt-blank {
      @include fs(16);

      flex: 0 0 calc(100% / 3 - 20px);
      height: 40px;
      color: $text1;
      border: 1px solid $border1;
      border-radius: 4px;
      text-align: center;
      margin-bottom: 20px;
      margin-right: 20px;

      &.interaction,
      &.system:hover {
        background-color: $main;
        color: $white;
        border: 1px solid $main;
      }
    }

    input:focus {
      outline: none;
    }
  }
}
</style>
